<template>
    <div>
        <div class="breadcrumb-section jarallax pixels-bg" data-jarallax data-speed="0.6">
            <div class="container text-center">
                <h1>{{ (service != null) ? service.name.toUpperCase() : '' }}</h1>
                <ul>
                    <li><router-link to="/">Accueil</router-link></li>
                    <li><router-link to="/nos-services">Nos services</router-link></li>
                    <li><a href="javascript:void(0);">{{ (service != null) ? service.name : '' }}</a></li>
                </ul>
            </div>
        </div>
        <div class="section-block">
            <div class="container">
                <div class="row mt-20" v-if="service != null">
                    <div class="col-md-6">
                        <p v-html="service.description"></p><br />
                        <router-link to="/contactez-nous" class="button-sm button-primary">Nous contacter</router-link>
                    </div>
                    <div class="col-md-6">
                        <img :src="url + '/' + service.image" alt="" srcset="" style="width:650;heigth:500;">
                    </div>
                </div>
                <div class="row mt-40" v-else>
                    <div class="col-md-12">
                        <div class="alert alert-info">
                            Chargement en cours ...
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from '../../config/urls'
export default {
  name: 'ServiceDetails',
  data () {
    return {
      service: null,
      url: BASE_URL,
      isLoading: false
    }
  },
  mounted () {
    this.getService()
  },
  methods: {
    getService () {
      this.isLoading = true
      let url = BASE_URL + API_PREFIX + API_VERSION + '/services-by-slug/' + this.$route.params.serviceSlug
      this.$http.get(url)
        .then((response) => {
          this.service = response.data
          this.isLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ServiceDetails.vue